import { useState } from 'react'
import { DataEntryTextField } from '../CustomStyles/StyledComponents';
import TextInputSearchButton from '../Buttons/TextInputSearchButton';
import { stripNonPrintable } from '../../helpers/stringFormatHelper';
import PropTypes from 'prop-types';


const SearchField = (props) => {
    let { onSearch, backgroundLoading, ...otherProps } = props;

    const [searchTerm, setSearchTerm] = useState("")

    const handleClick = () => {
        let final = stripNonPrintable(searchTerm);
        setSearchTerm(final);
        onSearch(final);
    }
    const onKeyUp = (e) => {
        if (e.key === "Enter") {
            handleClick()
            e.preventDefault();
        }
    }
    return (
        <DataEntryTextField
            size="small"
            variant="outlined"
            type='search'
            sx={{ width: { xs: "100%", sm: "75%", md: "75%", lg: "40%" } }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyUp={onKeyUp}
            disabled={backgroundLoading}
            slotProps={{
                input: {
                    startAdornment: (
                        <TextInputSearchButton position="start"
                            isLoading={backgroundLoading}
                            onClick={handleClick} />
                    ),
                },
            }}
            inputRef={input => input?.focus()}
            {...otherProps} />
    )
}

SearchField.propTypes = {
    backgroundLoading: PropTypes.bool,
    onSearch: PropTypes.func,
};
export default SearchField